"use client";

import { BenefitsSection } from "@/components/sections/benefits";
import { benefits } from "@/lib/data/services-brand-augmentation";

export function Benefits() {
  return (
    <BenefitsSection
      eyebrow={benefits.eyebrow}
      title={benefits.title}
      benefits={benefits.benefits}
      accent={benefits.accent}
      gridCols={benefits.gridCols}
    />
  );
}
